export default "__VITE_ASSET__DnfAGsXs__"